import createReducer from 'utils/createReducer';
import get from 'lodash/get';

// Module name
export const TICKET_SETTINGS_PAGE = 'ticketSettings';

// Actions constants
const addActionPrefix = (actionName) => `${TICKET_SETTINGS_PAGE}/${actionName}`;
const SET_EDIT_TICKET_TYPE_ID = addActionPrefix('SET_EDIT_TICKET_TYPE_ID');
const TOGGLE_COPY_MODAL = addActionPrefix('TOGGLE_COPY_MODAL');
export const LOAD_TICKET_SALE_FORM_COPY = addActionPrefix('LOAD_TICKET_SALE_FORM_COPY');

// Initial State
const INIT_STATE = {
    editTicketTypeId: null,
    isCopyFormModalOpened: false,
};

// Reducers
export default createReducer(INIT_STATE, {
    [SET_EDIT_TICKET_TYPE_ID]: (state, { editTicketTypeId }) => ({
        ...state,
        editTicketTypeId,
    }),
    [TOGGLE_COPY_MODAL]: (state) => ({
        ...state,
        isCopyFormModalOpened: !state.isCopyFormModalOpened,
    }),
});

// Action Creators
export const setEditTicketTypeId = (editTicketTypeId) => ({
    type: SET_EDIT_TICKET_TYPE_ID,
    editTicketTypeId,
});

export const loadTicketSaleFormCopy = (ticketId) => ({
    type: LOAD_TICKET_SALE_FORM_COPY,
    meta: ticketId,
});

export const toggleCopyFormModal = () => ({
    type: TOGGLE_COPY_MODAL,
});

// Selectors
export const getEditTicketTypeId = (state) => get(state, `${TICKET_SETTINGS_PAGE}.editTicketTypeId`);
export const isCopyFormModalOpened = (state) => get(state, `${TICKET_SETTINGS_PAGE}.isCopyFormModalOpened`);
